import React, { useEffect, createElement } from 'react';
const PIXEL_ID = '4433588043573862';
declare global {
  interface Window {
    fbq?: any;
    _fbq?: any;
  }
}
export function MetaPixel() {
  useEffect(() => {
    if (typeof window === 'undefined' || typeof document === 'undefined') return;
    // If already initialized, just fire PageView
    if (window.fbq) {
      try {
        window.fbq('track', 'PageView');
      } catch (e) {
        /* no-op */
      }
      return;
    }
    // Initialize fbq stub (queue calls until the real script loads)
    const f: any = window;
    const n: any = function () {
      n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
    };
    f.fbq = n;
    if (!f._fbq) f._fbq = n;
    n.push = n;
    n.loaded = true;
    n.version = '2.0';
    n.queue = [];
    // Inject the Facebook events script by appending to <head>
    const script = document.createElement('script');
    script.async = true;
    script.src = 'https://connect.facebook.net/en_US/fbevents.js';
    const target = document.head || document.body || document.documentElement;
    if (target) {
      target.appendChild(script);
    }
    // Queue init + PageView — these will execute once the script loads
    try {
      window.fbq('init', PIXEL_ID);
      window.fbq('track', 'PageView');
    } catch (e) {
      /* no-op */
    }
  }, []);
  return <noscript data-id="element-234">
      <img height="1" width="1" style={{
      display: 'none'
    }} src={`https://www.facebook.com/tr?id=${PIXEL_ID}&ev=PageView&noscript=1`} alt="" data-id="element-235" />
    </noscript>;
}